export default {
  paper: {
    borderRadius: 12,
    '@media (max-width:599.95px)': {
      margin: 16
    }
  },
  paperFullScreen: {
    borderRadius: 0,
    margin: 0,
    '@media (max-width:599.95px)': {
      margin: 0
    }
  }
};
